import { logger } from "../../shared/infra/logger.js";

export const ensureAudioContextClosed = (context: AudioContext) => {
  if (context.state === "closed") return;
  context.close().catch((err) => logger.warn({ err }, `Error closing audio context`));
};
